<template>
  <div id="thongBaoThanhCong" ref="thongBaoThanhCong">
    <div class="card mb-3">
      <div class="card-body">
        <h4 class="card-title text-center text-success text-uppercase">
          {{ $t("models.dangKyThanhCong.title") }} {{ dotdangky.tenDot }}
        </h4>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <h5 class="card-title text-uppercase">
          {{ $t("models.thiSinh.titleCard1") }}
        </h5>
        <div class="form-row pl-5">
          <div class="col-md-6 mb-3">
            <label>
              {{ $t("models.hoSo.maHoSo") }}:
              <span class="font-weight-bold">
                {{ dotdangkythisinh.id }}
              </span>
            </label>
          </div>
          <div class="col-md-6 mb-3">
            <label>
              {{ $t("models.hoSo.maDangKy") }}:
              <span class="font-weight-bold">
                {{ dotdangkythisinh.regCode }}
              </span>
            </label>
            <label class="text-danger">
              &nbsp; {{ $t("models.hoSo.noteMaDangKy") }}
            </label>
          </div>
          <div class="col-md-6 mb-3">
            <label>
              {{ $t("models.thiSinh.hoTen") }}: {{ thisinh.hoTen }}
            </label>
          </div>
          <div class="col-md-6 mb-3">
            <label>
              {{ $t("models.thiSinh.ngaySinh") }}: (ngày/tháng/năm):
              {{ formatDate(thisinh.ngaySinh) }}
            </label>
          </div>
          <div class="col-md-6 mb-3">
            <label>
              {{ $t("models.thiSinh.cmnd") }}: {{ thisinh.soCmnd }}
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="card mt-3">
      <div class="card-body">
        <h5 class="card-title text-uppercase" v-if="dotdangky.loaiDot != 'CAOHOC'">
          {{ $t("models.thiSinh.titleCard2") }}
				</h5>
        <h5 class="card-title text-uppercase" v-else>
          3. Thông tin học thạc sĩ 
        </h5>
        <div class="form-row pl-5">
          <v-container class="grey lighten-5">
            <v-card class="pa-2">
              <v-data-table
                :items="nguyenvongs"
                :disable-pagination="true"
                :hide-default-footer="true"
                :headers="headers"
              >
                <template v-slot:body="{ items }">
                  <tbody name="list" v-if="dotdangky.loaiDot !== 'CAOHOC'">
                    <tr
                      v-for="(item, index) in items"
                      :key="item.khoaId"
                      class="p-4"
                    >
                      <td class="pt-3 pb-3">
                        <span class="text-data">
                          {{ index + 1 }}
                        </span>
                      </td>
                      <td class="pt-3 pb-3">
                        <span class="text-data">
                          {{ getMaNganh(item.nganhId) }}
                        </span>
                      </td>
                      <td class="pt-3 pb-3">
                        <span class="text-data">
                          {{ getTenNganh(item.nganhId) }}
                        </span>
                      </td>
                      <td class="pt-3 pb-3" v-if="dotdangky.loaiDot != 'THI'">
                        <span class="text-data">
                          {{ item.maToHop }} ({{ item.tenToHop }})
                        </span>
                      </td>
                      <td class="pt-3 pb-3" v-if="dotdangky.loaiDot != 'THI'">
                        <span class="text-data">
                          {{ item.diemXetTuyen }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                  <tbody name="list" v-else>
                    <tr
                      v-for="(item, index) in items"
                      :key="index"
                      class="p-4"
                    >
                      <td class="pt-3 pb-3">
                        <span class="text-data">
                          {{ index + 1 }}
                        </span>
                      </td>
                      <td class="pt-3 pb-3">
                        <span class="text-data">
                          {{ getMaNganh(item.nganhId) }}
                        </span>
                      </td>
                      <td class="pt-3 pb-3">
                        <span class="text-data">
                          {{ getTenNganh(item.nganhId) }}
                        </span>
                      </td>
                      <td class="pt-3 pb-3">
                        <span class="text-data">
                          {{ item.dinhHuong }}
                        </span>
                      </td>
                      <td class="pt-3 pb-3">
                        <span class="text-data">
                          {{ item.nganhId | tenCoSo(nganhs, cosoes) }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </v-card>
          </v-container>
        </div>
        <div class="form-row pl-5">
          <div class="col-md-12 mb-1 text-danger">
            <label>
              {{ $t("title.tgianCongBo") }}:
              {{ formatDate(dotdangky.ngayCongBo) }} (dự kiến)
            </label>
          </div>
          <div class="col-md-12 mb-1">
            <label class="text-danger">
              {{ $t("models.hoSo.noteChinhNv") }}:
            </label>
            <router-link
              :to="{ name: 'dieu-chinh-nguyen-vong' }"
              class="text-primary ml-2"
            >
              {{ url }}
            </router-link>
          </div>
          <div class="col-md-12 mb-1">
            <label class="text-danger">
              {{ $t("models.hoSo.noteSendMail") }}:
            </label>
            <a
              class="font-weight-bold text-primary text-decoration-underline"
              style="cursor: pointer"
              @click="clickDownFileDangKy(dotdangkythisinh.regCode)"
            >
              {{ $t("button.taiDay") }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="card mt-3">
      <div class="card-body">
        <h5 class="card-title text-uppercase">
          {{ $t("models.thiSinh.titleCard3") }}
        </h5>
        <div class="form-row pl-5">
          <div class="col-md-12 mb-1">
            Đề nghị thí sinh tham gia nhóm Zalo đăng ký xét tuyển cao học để thuận lợi cho việc nhận thông báo, liên hệ” bằng cách quét mã QR hoặc click vào link nhóm: 
            <a :href="dotdangky.linkNhom" target="_blank">{{ dotdangky.linkNhom }}</a>
          </div>
          <qr-code :text="dotdangky.linkNhom"></qr-code>
          <div class="col-md-12 mb-1">
            <label class="">
              {{ $t("models.hoSo.lePhi") }}: {{ lephi }}
              {{ $t("title.noteLePhi") }}
            </label>
          </div>
          <div class="col-md-12 mb-1">
            <label class="font-weight-bold">
              {{ $t("title.titleChuyenKhoan") }}:
            </label>
            <ul>
              <li>
                {{ $t("title.titleSKT") }}:
                <span class="font-weight-bold">
                  {{ $t("title.soTaiKhoan") }}
                </span>
              </li>
              <li>
                {{ $t("title.titleTTK") }}:
                <span class="font-weight-bold">
                  {{ $t("title.tenTk") }}
                </span>
              </li>
              <li>
                Tại:
                <span class="font-weight-bold">
                  {{ $t("title.chiNhanh") }}
                </span>
              </li>
              <li>
                Số tiền:
                <span class="font-weight-bold">{{ lephi }} VNĐ</span>
              </li>
              <li>
                Nội dung:
                <span class="font-weight-bold" v-if="dotdangky.loaiDot !== 'CAOHOC'">
                  LPXT {{ thisinh.hoTen }} {{ thisinh.soCmnd }}
                </span>
                <span class="font-weight-bold" v-else>
                  LPCHD {{ thisinh.hoTen }} {{ thisinh.soCmnd }}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <dialog-loader ref="dialogLoader"></dialog-loader>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { _message } from "@/helpers/_message";
import DialogLoader from "@/components/dialog/DialogLoader.vue";
import VueQRCodeComponent from 'vue-qrcode-component'
export default {
  components: {
    DialogLoader,
    'qr-code': VueQRCodeComponent,
  },
  data() {
    return {
      title: "",
      url: "",
      httpDownload: "",
      tongSoTien: 0,
      lephi: 0,
      headers: [
        { text: "Số thứ tự", class: "text-uppercase" },
        { text: "Mã ngành", class: "text-uppercase" },
        { text: "Tên ngành", class: "text-uppercase" },
        { text: "Tổ hợp", class: "text-uppercase" },
        { text: "Điểm", class: "text-uppercase" },
      ],
    };
  },
  computed: {
    ...mapState({
      nganhs: (state) => state.nganh.nganhs,
      cosoes: (state) => state.coso.cosoes,
      nguyenvongs: (state) => state.nguyenvong.nguyenvongs,
      diems: (state) => state.tohop.diems,
      tinhs: (state) => state.truong.tinhs,
      thisinh: (state) => state.thisinh.thisinh,
      mons: (state) => state.tohop.mons,
      dotdangky: (state) => state.dotdangky.dotdangky,
      dotdangkythisinh: (state) => state.dotdangkythisinh.dotdangkythisinh,
    }),
  },
  methods: {
    ...mapActions({
      downloadFileDangKy: "thisinh/downloadFileDangKy",
    }),
    getUrl() {
      this.url =
        window.location.origin +
        this.$router.resolve({ name: "dieu-chinh-nguyen-vong" }).href;
    },
    clickDownFileDangKy(regCode) {
      this.$root.$dialogLoader.show(this.$t("message.download.title"), {});
      this.downloadFileDangKy(regCode).then((response) => {
        if (response.status === 404) {
          _message.messageNotHaveFileDownload();
        }
        this.$root.$dialogLoader.hide();
      });
    },
    formatDate(date) {
      let d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [day, month, year].join("/");
    },
    getTenNganh(nganhId) {
      let data = this.nganhs.find((item) => item.nganhId == nganhId);
      return data?.tenNganh;
    },
    getMaNganh(nganhId) {
      let data = this.nganhs.find((item) => item.nganhId == nganhId);
      return data?.maNganh;
    },
    scrollMeTo(refName) {
      var element = this.$refs[refName];
      var top = element.offsetTop;

      window.scrollTo(0, top);
    },
  },
  created() {
    this.getUrl();
    window.scrollTo(0, 0);
    if (this.dotdangky.loaiDot == "THI") {
      this.headers = [
        { text: "Số thứ tự", class: "text-uppercase" },
        { text: "Mã ngành", class: "text-uppercase" },
        { text: "Tên ngành", class: "text-uppercase" },
      ];
    }
    if (this.dotdangky.loaiDot == "CAOHOC") {
      this.headers = [
        { text: "Số thứ tự", class: "text-uppercase" },
        { text: "Mã ngành", class: "text-uppercase" },
        { text: "Tên ngành", class: "text-uppercase" },
        { text: "Định hướng", class: "text-uppercase" },
        { text: "Nơi học", class: "text-uppercase" },
      ];
    }

    this.lephi = this.dotdangky.lePhiXetTuyen;
    this.tongSoTien = this.dotdangky.lePhiXetTuyen
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    this.httpDownload = `${process.env.VUE_APP_API}${process.env.VUE_APP_DOWNLOAD}/dangky`;
  },
  mounted() {
    this.$root.$dialogLoader = this.$refs.dialogLoader;
  },
  filters: {
    tenCoSo: function (value, nganhs, cosoes) {
			let nganh = nganhs.find((item) => item.nganhId == value);
			let coso = cosoes.find(item => item.coSoId == nganh?.coSoId);
			return `${coso?.tenCoSo}`;
		},
  }
};
</script>

<style scoped></style>
